import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAdminUser } from '@/lib/role-guards'

import { MembershipRenewalsPage } from '@/features/admin/renewals'
export const Route = createFileRoute('/_authenticated/admin/renewals')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: MembershipRenewalsPage,
})
